import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import PrimarySmallBlueButton from "../customButtons/PrimarySmallBlueButton";
import DoneIcon from "@mui/icons-material/Done";
export default function SussceeffulyMessageScreen({
  maxWidth,
  title,
  open,
  text,
  subText,
  buttonTitle,
  startIcon,
  navigateLink,
  handleClose,
  currentLink,
  refreshPage=true
}) {
  const navigate = useNavigate();
  const handleNavigate = () => {

    if(!refreshPage) {
       handleClose();
       return;
    }

    if (currentLink === navigateLink) {
      setTimeout(() => {
        window.location.reload();
      });
    } else {
      handleClose();
      navigate(navigateLink);
    }
  };
  return (
    <>
      <Dialog
        onClose={handleClose}
        open={open}
        maxWidth={maxWidth}
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "12px", // 👈 custom border radius here
          },
        }}
      >
        <DialogTitle
          textAlign="start"
          color="#572575"
          mb={2}
          fontFamily="Inter"
          fontSize="20px"
     
        >
          {title ? title : ""}{" "}
        </DialogTitle>
        <DialogContent>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={2}
            p={2}
          >
            <Grid item xs={12} textAlign="center">
              <IconButton
                sx={{
                  width: 81,
                  height: 81,
                  backgroundColor: "#8A40B51A",
                  borderRadius: "50%",
                  backdropFilter: "blur(4px)",
                  overflow: "visible", // :white_tick: allow image overflow
                  position: "relative",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.4)",
                  },
                }}
              >
                <Box
                  component="img"
                  src="/newdashboard/b52cba1db9239e6d81162b8c4713b16a8081fe2a.gif"
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)", // :white_tick: keep it centered
                    pointerEvents: "none", // :white_tick: so click still works on button
                  }}
                />
              </IconButton>
            </Grid>
            <Grid item xs={12} textAlign="center">
              <Typography
                fontSize="22px"
                color="#8A40B5"
                sx={{
                  fontWeight: 600,
                  fontFamily: "Inter",
                  lineHeight: "100%",
                  fontStyle: "normal",
                  letterSpacing: "0%",
                }}
              >
                {text}
              </Typography>
            </Grid>
            {subText && (
              <Grid item xs={12} textAlign="center">
                <Typography
                  fontSize="14px"
                  color="#555555"
                  sx={{
                    fontWeight: 400,
                    fontFamily: "Inter",

                    fontStyle: "normal",
                    letterSpacing: "0.1px",
                  }}
                >
                  {subText}
                </Typography>
              </Grid>
            )}
            {/* Cancel Button */}
            <Grid
              item
              container
              gap={2}
              justifyContent="center"
              alignItems="center"
              mt={2}
              mb={2}
            >
              <PrimarySmallBlueButton
                startIcon={<DoneIcon/>}
                buttonTitle={buttonTitle}
                onClick={handleNavigate}
              />
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
}
